import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
`;

export const Bone = styled.div`
  animation: ${shimmer} 1.4s linear infinite;
  background: linear-gradient(90deg, #ecf1f4 0%, #f7f9fb 45%, #ecf1f4 90%);
  background-size: 200% 100%;
  border-radius: 0;
  height: ${props => props.$h || "16px"};
  width: ${props => props.$w || "100%"};
`;

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DetailTopBar = styled.div`
  align-items: center;
  background-color: var(--CLOUD, #fcfdfe);
  border-bottom: 1px solid #e4e4e4;
  display: flex;
  height: 72px;
  justify-content: space-between;
  padding: 24px;
`;

export const DetailTopBarSide = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

export const TabsRow = styled.div`
  align-items: center;
  display: flex;
  gap: 32px;
  height: 48px;
  margin: 0 24px;
`;

export const ItemsHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 12px 24px;
`;

export const Table = styled.div`
  border-top: 1px solid #e9edf5;
  border-bottom: 1px solid #e9edf5;
  margin: 12px 24px;
  overflow: hidden;
`;

export const TableHead = styled.div`
  background: #f7f8f9;
  display: grid;
  gap: 12px;
  grid-template-columns: ${props =>
    props.$columns
      ? `repeat(${props.$columns}, minmax(0, 1fr))`
      : "2fr 1.5fr 0.8fr 0.8fr 0.8fr 0.8fr 1fr 0.8fr 1.2fr 0.8fr"};
  padding: 12px 16px;
`;

export const TableRow = styled.div`
  border-top: 1px solid #e9edf5;
  display: grid;
  gap: 12px;
  grid-template-columns: ${props =>
    props.$columns
      ? `repeat(${props.$columns}, minmax(0, 1fr))`
      : "2fr 1.5fr 0.8fr 0.8fr 0.8fr 0.8fr 1fr 0.8fr 1.2fr 0.8fr"};
  padding: 14px 16px;
`;
